import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("joudi-lang") === "en" ? "en" : "de";
    } catch {
      return "de";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("joudi-lang", lang);
    } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
